import { useQuery } from '@tanstack/react-query';

import { Auth } from '@air/api';

export const CURRENT_SESSION = 'CURRENT_SESSION';

export const getCurrentSessionKey = () => [CURRENT_SESSION];

export const useCurrentUserSession = () => {
  return useQuery({
    queryFn: Auth.getCurrentSession,
    queryKey: getCurrentSessionKey(),
    staleTime: 1000 * 60 * 60 * 24,
  });
};
